module.exports = __webpack_public_path__ + "static/DSC_9523-f165ea83f4d9302c3b24020aab0570f4.jpg";